import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledMenuButton = styled.div<{ isOpen: boolean }>`
  display: flex;
  outline: none;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.token.var('borderRadius.small')};
  background: ${({ isOpen }) => (isOpen ? theme.token.var('colors.gray.a100)') : theme.token.var('colors.light'))};
  transition: background 0.3s ease;
  position: relative;
  cursor: pointer;
  color: ${theme.token.var('colors.green.a250')};

  img {
    pointer-events: none;
  }
`
